import { type UseQueryResult, useQuery } from 'react-query';
import { BrokerFixChannelSettingsService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
// eslint-disable-next-line camelcase
import type { Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerLinkedCompanyFixDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';

export const linkedCompaniesFixQueryKey = (brokerCompanyId: string) =>
  ['linkedCompaniesFix', brokerCompanyId] as const;

type UseGetBrokerLinkedCompaniesFixOptions = {
  enabled?: boolean;
};

const useGetBrokerLinkedCompaniesFix = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  brokerCompanyId: string,
  options?: UseGetBrokerLinkedCompaniesFixOptions
): UseQueryResult<
  Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerLinkedCompanyFixDto[] | undefined,
  unknown
> => {
  const enabled = (options?.enabled ?? true) && Boolean(brokerCompanyId);

  const linkedCompaniesFix = useQuery(
    linkedCompaniesFixQueryKey(brokerCompanyId),
    async () => {
      return await handleRequest(
        BrokerFixChannelSettingsService.getApiAwardSettlementApiAppBrokerFixChannelSettingsLinkedCompaniesFix(
          brokerCompanyId
        )
      );
    },
    { enabled }
  );
  return linkedCompaniesFix;
};

export default useGetBrokerLinkedCompaniesFix;
